export default {
      id: "btn_star-usage",
      viewBox: "0 0 23 22",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#btn_star",
      toString: function () {
        return this.url;
      }
    }